/*eslint-disable*/
import Vue from 'vue';
import Vuex from 'vuex';
import dialog from '@/utils/dialog';
import {
  login,
  nextStep,
  submitAnswer,
  submitWelcome,
  applyLessonTime,
  getAllQuestion,
} from '@/api/base';
import {
  setToken,
  setUserLocalData,
  getUserLocalData,
} from '@/utils/auth';
import {
  showErrMessage,
} from '@/utils';
import getters from './getters';

Vue.use(Vuex);
let lastCb;
const store = new Vuex.Store({
  state: {
    component: {
      id: '',
      source: {},
    },
    module: {
      moduleType: '',
      moduleName: '',
      goalType: 1, // 对应关系找产品要
    },
    topic: {
      topicId: '',
      topicName: '',
    },
    moduleStatus: {

    },
    isLoading: false,
    wapAllQuestion: {
      questionList: [],
      currentPage: 0,
      totalNum: 0,
      totalRightNum: 0,
      totalWrongNum: 0,
      isOver: false,
    },
    qTime: 0,
    questionId: '',
    showVideoTip: true,
    showNoticeTip: false,
    showTimeoutNotice: false,
    shareData: {
      module: {
        moduleType: '',
        moduleName: '',
        goalType: 1, // 对应关系找产品要
      },
    },
    stopTimer: false, //  是否執行跳過操作 提交答案時 暫停用時
    routeName: '', // 存儲路由的名字
    pkgMsg: '',
    reportInfo: '',
    reportQuesNum: 0,
    count: 0,
    autoRobot: !1,
  },
  mutations: {
    NEXT_STEP: (state, data) => {
      const {
        component,
        module,
        topic,
        moduleStatus,
      } = data.data;
      // console.log({
      //   component,
      //   module,
      //   topic
      // })
      state.component = component;
      state.module = module;
      state.topic = topic,
      state.moduleStatus = moduleStatus;
    },
    SET_REPORT_INFO: (state, data) => {
      state.reportInfo = data;
    },
    SET_REPORT_QUES_NUM: (state, data) => {
      state.reportQuesNum = data;
    },
    SET_LOADING: (state, data) => {
      state.isLoading = data;
    },
    SET_WAP_ALL_QUESTIONS: (state, data) => {
      const questions = state.wapAllQuestion.questionList.concat(data.questionList);

      state.wapAllQuestion.questionList = questions;
      state.wapAllQuestion.currentPage = data.currentPage;
      state.wapAllQuestion.totalNum = data.totalNum;
      state.wapAllQuestion.totalRightNum = data.totalRightNum;
      state.wapAllQuestion.totalWrongNum = data.totalWrongNum;

      const {
        totalNum,
        questionList,
      } = state.wapAllQuestion;

      if (totalNum === 0 || totalNum === questionList.length) {
        state.wapAllQuestion.isOver = true;
      }
    },
    SET_OPTIONS: (state, data) => {
      state.component.source.questionInfo.options = data;
    },
    SET_QTIME: (state, data) => {
      state.qTime = data;
    },
    SET_QUESTION_ID: (state, data) => {
      state.questionId = data;
    },
    CLOSE_VIDEO_TIP: (state) => {
      state.showVideoTip = false;
    },
    SET_NOTICE_TIP: (state, data) => {
      state.showNoticeTip = data;
    },
    SET_TIMEOUT_NOTICE: (state, data) => {
      state.showTimeoutNotice = data;
    },
    SET_COMMON_DATA: (state, data) => {
      state.shareData = data;
    },
    SET_STOP_TIMER: (state, data) => {
      state.stopTimer = data;
    },
    SET_ROUTE_NAME: (state, data) => {
      state.routeName = data;
    },
    UPDATE_PKG_MSG: (state, data) => {
      state.pkgMsg = data;
    },
    // 设置自动答题机器人
    SET_AUTO_ROBOT: (state, data) => {
      state.autoRobot = data;
    },
  },
  actions: {
    login({
      commit,
    }, data) {
      return new Promise(async (resolve, reject) => {
        let res;
        try {
          res = await login(data);
        } catch (e) {
          showErrMessage(e, '登录失败');
          reject();
          return;
        }

        setToken(res.token);
        setUserLocalData(res.data);

        resolve(res);
      });
    },
    nextStep({ dispatch, commit }, { isSubmit, isContinue, cb } = { isSubmit: 0, isContinue: 0 }) {
      return new Promise(async (resolve, reject) => {
        const { topicId, userId, courseId } = getUserLocalData();
        let res;
        if (typeof cb !== 'undefined') {
          lastCb = cb;
        }
        try {
          if (isContinue) {
            res = await nextStep({ isSubmit, topicId, isContinue });
          } else {
            res = await nextStep({ isSubmit, topicId });
          }
        } catch (e) {
          showErrMessage(e, '获取下一步数据失败');
          reject();
          return;
        }
        // res.data.courseHourData = {
        //   code: 200,
        //   data: {
        //     applyTimes: [120, 240, 360, 480],
        //     remark: 0
        //   },
        //   msg: '顺利完成首次学习体验，课程正式计时开始啦！'
        // };
        const { code } = res;
        const pkgCode = res.data.courseHourData.code;

        if (code === 200 && pkgCode === 200) {
          commit('NEXT_STEP', res);
          console.log('success');
          resolve(res);
        }

        if (pkgCode !== 200) {
          const pkgData = res.data.courseHourData.data;
          const pkgMsg = res.data.courseHourData.msg;

          let opts = {};
          if (pkgCode === 8930003) {
            opts = {
              onSure: () => dispatch('nextStep', { isContinue: 1 }).then((r) => {
                if (r.code === 200 && r.data.courseHourData.code === 200) {
                  lastCb();
                }
              }),
              msg: pkgMsg,
            };
          }

          if (pkgCode === 8930004) {
            commit('UPDATE_PKG_MSG', pkgMsg);
            const timeList = pkgData.applyTimes;
            const { remark } = pkgData;
            const params = {
              userId,
              topicId,
              courseId,
            };

            opts = {
              onSure: () => dispatch('applyLessonTime', params).then(() => {
                dispatch('nextStep').then((r) => {
                  if (r.code === 200 && r.data.courseHourData.code === 200) {
                    lastCb();
                  }
                });
              }),
              timeList,
              msg: pkgMsg,
              remark,
            };
          }

          if (pkgCode === 8930005 || pkgCode === 8930006) {
            opts = {
              onSure: () => dispatch('nextStep').then((r) => {
                if (r.code === 200 && r.data.courseHourData.code === 200) {
                  console.log('8930006 oooooo');
                  lastCb();
                }
              }),
              msg: pkgMsg,
            };
          }

          if (pkgCode === 8930007) {
            opts = {
              onSure: () => {
                const params = {
                  userId,
                  topicId,
                  courseId,
                };
                const timeList = pkgData.applyTimes;
                const msg = store.state.pkgMsg;
                const { remark } = pkgData;

                dialog.init(8930004, {
                  onSure: () => dispatch('applyLessonTime', params).then(() => {
                    dispatch('nextStep').then((r) => {
                      if (r.code === 200 && r.data.courseHourData.code === 200) {
                        lastCb();
                      }
                    });
                  }),
                  timeList,
                  msg,
                  remark,
                  reChoose: 1,
                });
              },
              msg: pkgMsg,
            };
          }
          dialog.init(pkgCode, opts);

          resolve({ code: pkgCode });
        }
      });
    },
    applyLessonTime({ dispatch, commit }, data) {
      return new Promise(async (resolve, reject) => {
        const radio = $('.sq-dialog-times-list input[name="radio"]:checked');

        if (radio) {
          const time = radio.attr('data-value');
          const params = { ...data, timeLength: parseInt(time) };

          let res;
          try {
            res = await applyLessonTime(params);
          } catch (e) {
            showErrMessage(e, '申请课时失败!');
            reject();
            return;
          }

          if (res.code === 200) {
            resolve();
          } else {
            reject();
          }
        }
      });
    },
    setLoading({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', data);
        resolve();
      });
    },
    getWapAllQuestions({
      commit,
    }, data) {
      return new Promise(async (resolve, reject) => {
        let res;
        const params = {
          ...data,
          perPage: 60,
        };
        try {
          res = await getAllQuestion(params);
        } catch (e) {
          showErrMessage(e, '获取问题列表数据失败');
          reject();
          return;
        }

        commit('SET_WAP_ALL_QUESTIONS', res.data);
        resolve(res);
      });
    },
    setOptions({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_OPTIONS', data);
        resolve();
      });
    },
    setQtime({
      commit,
    }, data) {
      commit('SET_QTIME', data);
    },
    shareCommonData({
      commit,
    }, data) {
      commit('SET_COMMON_DATA', data);
    },
    stopTimer({
      commit,
    }, data) {
      commit('SET_STOP_TIMER', data);
    },
    routeName({
      commit,
    }, data) {
      commit('SET_ROUTE_NAME', data);
    },
    setQuestionid({
      commit,
    }, data) {
      commit('SET_QUESTION_ID', data);
    },
    closeVideoTip({
      commit,
    }) {
      commit('CLOSE_VIDEO_TIP');
    },
    setNoticeTip({
      commit,
    }, data) {
      commit('SET_NOTICE_TIP', data);
    },
    setTimeoutNotice({
      commit,
    }, data) {
      commit('SET_TIMEOUT_NOTICE', data);
    },
    setReportInfo({ commit }, data) {
      commit('SET_REPORT_INFO', data);
    },
    setReportQuesNum({ commit }, data) {
      commit('SET_REPORT_QUES_NUM', data);
    },
    // 设置自动答题机器人
    setAutoRobot({
      commit,
    }, data) {
      commit('SET_AUTO_ROBOT', data);
    },
  },
  getters,
});

export default store;
